import React from "react";

const Pagination = ({ totalPages, currentPage, onPageChange }) => {
  const maxVisiblePages = 3; // Jumlah halaman yang ditampilkan sebelum muncul "..."
  let pages = [];

  if (totalPages <= maxVisiblePages) {
    // Jika total halaman kurang dari atau sama dengan maxVisiblePages, tampilkan semua
    pages = Array.from({ length: totalPages }, (_, i) => i + 1);
  } else {
    if (currentPage <= 2) {
      // Jika di awal (halaman 1 atau 2)
      pages = [1, 2, "...", totalPages];
    } else if (currentPage >= totalPages - 1) {
      // Jika di akhir (halaman terakhir atau sebelumnya)
      pages = [1, "...", totalPages - 1, totalPages];
    } else {
      // Jika di tengah
      pages = [1, "...", currentPage, "...", totalPages];
    }
  }

  return (
    <nav>
      <ul className="pagination justify-content-center mt-5">
        {/* Tombol Previous */}
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(currentPage - 1)}
          >
            Previous
          </button>
        </li>

        {/* Looping halaman */}
        {pages.map((page, index) => (
          <li
            key={index}
            className={`page-item ${currentPage === page ? "active" : ""} ${
              page === "..." ? "disabled" : ""
            }`}
          >
            {page === "..." ? (
              <span className="page-link">...</span>
            ) : (
              <button className="page-link" onClick={() => onPageChange(page)}>
                {page}
              </button>
            )}
          </li>
        ))}

        {/* Tombol Next */}
        <li
          className={`page-item ${
            currentPage === totalPages ? "disabled" : ""
          }`}
        >
          <button
            className="page-link"
            onClick={() => onPageChange(currentPage + 1)}
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
